import { render, staticRenderFns } from "./InboundPolicyForm.vue?vue&type=template&id=65f69976"
import script from "./InboundPolicyForm.vue?vue&type=script&lang=js"
export * from "./InboundPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports